import React, { useEffect, useState } from 'react';

import JsonView from '@uiw/react-json-view';
import { githubLightTheme } from '@uiw/react-json-view/githubLight';
import { Card, Divider, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { GeoVictoriaMigrationLogRowSchema } from '../GeoVictoriaToBukMigration';

interface GeoVictoriaMigrationDetailModalProps {
  selectedLog: GeoVictoriaMigrationLogRowSchema;
  handleGeoVictoriaMigrationDetailModalCancel: () => void;
  isGeoVictoriaMigrationDetailModalOpen: boolean;
}

const COLLAPSE_NUMBER = 2;

function GeoVictoriaMigrationDetailModal({
  isGeoVictoriaMigrationDetailModalOpen,
  selectedLog,
  handleGeoVictoriaMigrationDetailModalCancel,
}: GeoVictoriaMigrationDetailModalProps) {
  const [form] = Form.useForm();
  const [collapse] = useState(COLLAPSE_NUMBER);
  const { t } = useTranslation();

  useEffect(() => {
    if (isGeoVictoriaMigrationDetailModalOpen) {
      form.resetFields();
    }
  }, [isGeoVictoriaMigrationDetailModalOpen]);

  return (
    <Modal
      title={t(
        'scenes.geovictoria.geo_victoria_to_buk_migration.components.migration_detail_modal.title',
        { id: selectedLog.id }
      )}
      open={isGeoVictoriaMigrationDetailModalOpen}
      footer={false}
      onCancel={handleGeoVictoriaMigrationDetailModalCancel}
      maskClosable={false}
    >
      <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />

      <Form layout="vertical">
        <Form.Item
          label={t(
            'scenes.geovictoria.geo_victoria_to_buk_migration.components.migration_detail_modal.labels.process_type'
          )}
        >
          <Input
            readOnly
            value={
              selectedLog.key === 'GEO_VICTORIA_MIGRATION_TO_BUK_PROCESS'
                ? t(
                    'scenes.geovictoria.geo_victoria_to_buk_migration.scene.table.process_map.basic_migration'
                  )
                : selectedLog.key
            }
          />
        </Form.Item>

        <Form.Item
          name="params"
          label={t(
            'scenes.geovictoria.geo_victoria_to_buk_migration.components.migration_detail_modal.labels.params'
          )}
        >
          <Card>
            <JsonView
              value={selectedLog.params}
              style={githubLightTheme}
              collapsed={collapse}
              displayDataTypes={false}
            />
          </Card>
        </Form.Item>

        <Form.Item
          name="payload"
          label={t(
            'scenes.geovictoria.geo_victoria_to_buk_migration.components.migration_detail_modal.labels.payload'
          )}
        >
          <Card>
            <JsonView
              value={selectedLog.payload}
              style={githubLightTheme}
              collapsed={1}
              displayDataTypes={false}
            />
          </Card>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default GeoVictoriaMigrationDetailModal;
